export default "__VITE_PUBLIC_ASSET__e98384c7__"